import * as React from "react";
import {
  RiDownloadLine,
  RiImageLine,
  RiErrorWarningLine,
  RiBook2Line,
  RiGlobalLine,
  RiMapPinLine,
} from "@remixicon/react";
import { cn } from "../../../lib/utils";
import { SystemTooltip } from "../SystemTooltip";

const USFlagIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect y="0.5" width="12" height="12" fill="url(#pattern0_usflag)" />
    <defs>
      <pattern
        id="pattern0_usflag"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_usflag" transform="scale(0.00195312)" />
      </pattern>
      <image
        id="image0_usflag"
        width="512"
        height="512"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAACAKADAAQAAAABAAACAAAAAAAL+LWFAABAAElEQVR4AeydB3xUxfbHJ7spQEijiUjvxUIXpSsISBF7e+oT9WGvz/5XwQpW7IC9vIeioogNC4igSC+hhVBDCiGkbnrb8j+zsGGTbLn37u37m88n7O69U858Z9k598yZMxEMCQRAQNcEXC5X1JOf7+5TZa/tUVUT0a2yxtm2xuFsXetwJtntrsRapyuuxu6Mrax1Na2ocsRU2V3RlTWOyOoaZySLYBGWCGapqHGyWrsrgnc0gq6VVDiY0+Vito9HePpeS2/KPB9Ovtro1UF/xfRXQ3/lERERFSRPOb3n97z/ivhnupdrt9vzWrVqlUt57XQNCQRAQKcE3D8IOpUNYoGA6Qm8//PezgeO1g4prqo5u7TS1bu8yt6hstbZuqLakVhYZm9mq6iNpleL3eFShIWXAqBE/XmkBOSSUpBHf1n0/ij9ZTkcjnR6zbRarVnx8fH5SjSMOkEABIITgAIQnBFygIBkAjTxWZ9elDo0p7ByVFlV7Tll1c7uxRWOdgWltS2O2WqaFJbVavp/UGEFQAi3Ssp0kP4OnXx1vyduBxMTEzNIUXAKqQR5QAAExBPQ9MdHvLgoAQL6JfDgh8kDyqod420V9mFF5Y7eRWW1p6flViUUaDzJByKmAwUgkHg1XBEgJWAPvabwV7IepLRo0SKV3vOlCSQQAIEQCEABCAEeioYngdcXZzbdl5c7qbjKfnF+sX3o0aLqLul5Vc35OrvRks4VAH84a0khOEA3t/I/er+1qqpqW7t27Sr8FcB1EACBxgSgADRmgisgUEdg1uI90baSmott5fap+aW152YV1HTZd6yiGTni1eUx8huDKgC+kHOHwxT620R/G5xO58akpCRuNTDHQPnqMa6BQIgEoACECBDFzUVgycaslrsPF1+fml0xPS2v4uw9mZUtSirtpv1/YiIFwNcXsYQubqa/DaQI/F1TU7O2devWpb4y4hoIhCMB0/6wheNgos/iCTz8yaa2xRXWG2mdflp6XnW/XRllidV2ZTzuxUunfAmTKwANATpouWAfKQNr6cZKi8XyB3YhNESEz+FEAApAOI02+sreWn4g/kBm6W0ZhTVX7M+uOHtfdmUzvh8+XFOYKQANh5kvD+ygvxX8LyEhYS0pB1UNM+EzCJiVAJYAzDqy6FcdgVmL90TbSmom08Q/yOF0qNm0ItoK14zPl g/dXZBuirxASBCQQOJusAOtoWeC96urqJ9q2bWuuGNgSgJixSNg6gJlxMD194g49ZM77gD739FyT6zW/tJbd9fEB9uuOQrmqrKsnvqmVzbupO7tsaOu6a+H+Zv+xCnbLgn2KnUGAswDC/RsmqP+HKddMOnZ4paDcyGQYAlAADDNUwQWliZ8fETqXct5Gf7KP7Zq9Njbzg/0sx1YTXJgQclxzfhv2xo3dWdPo8F6h+mpdLnvw84Osoka5LZpQAEL4ooZf0W/ojIE74uPjC8Kv6+bsseyThDkx6b9XhYWFU+k/5/sk6RlyS2t3uNirP2Wyl3/MZE6XOssJPOTux7f3Yv3ax8rdHd3XV7pYA/QxP/txjzFZYUdPlYVBMAxhM7mbTZsy3chDwCbNkSJVFK8izJEN1BRERXE4LASJjaiwLhh5ckSQoPUCVWAQEQ6EYAB6ZuMDAJAv1NQLpbQDZs/2AEf632Mb71xjix9Xqq0HbDLDS0RgtNLTq1C2hZXK3KDlDycuXOnj4XzHJTjs05izNYJe8sptlF9VfZuGK1mN0wM/lr+8RvQTTuXUTdqaGjp9iGCAvCBiBgLO4JKJywVfvZNz6JA6xOTETAX84oHMLyUP81bz7/tHCavbe/uDKygeeqb1L8F4ydAIoEACIRAYMQOaeVrEM4CTemj9baffqtBNYT37/uNqsIyQCMkuAACIBCcAD2sC/YDEKQAFBYWnk2d6iS0Y3hKEkqqfj6pMf79nRlQv3Z8akhAavRK+F00JInPIAACOiLQlZbsewuRR5ACQN7/E4VU5skTKK66Jw9eGxOQOrHwUwOHdItrXCGuBCQglffwXvE+Tw0M2BhuggAIqEMAe erSPNOQWAHwI+M+Oq6pyq+n+nL3HBDM5JHN csmPycPxSl2S5cBtwFAARAIFuL0+n8d0JCwrpggkee5e3W+AJYDGptS4PO4EvBd Hq8gAAIgIAaC4BoPZsvKy raNGvW1C5WgX8nf U1hYmGCxWPbQZ03PTvbIg1cQAAEQAAFfBOLtdvuzyjYhr HbdHZICM+eblq7VYb37/uNqQMKPFIE+CdH0eT3kS85uiwEjPJuHpb4qUstWzDudBIPgIkEAA BYITuPNd/PTOBNP UeDhq3VdWHrWHeN9U8j7cn h5 B6GAEROSdCCAJkIBnscNe4 YlkPE6Ow kG qkPqCdEAAB9QiY9cnf5zJC3b6DewHoM AvEwBDMtbTn92OC9dLYCA4eBkqUJpAnpT0kqQIAAQCICAH wJOxyPBpyG8Fq4 8I05PFI0e8aZwSABMAfeiCgJoEmun4Gi8LK 0NRa6JMl3NldWYWC5eOWtqaaW19kkVo5BIAABACgO4FBsN0r9dLuHZdC5Vdv7pfbCg0 qTAPYUqOZ9L4AAGAj4JED7qhEA0WwUi4Hzd4ZyqAC8kCQQAAHzEvB9WOQvALhHaC/hVRXeLdE 19 j7VYbP7 udosIq0kEABBQg4MHXABFsNIqUJbXJo CZ9D6 j1XYPeB9W5 z7tIq w0WAB4DAOaB8DP4BghkJXC5X1JK t2dJbXJQa6IAldWwywAMAYS4BRh8 8LKx0NPQ30J99D6ZUl5aZ4AGH0MQFBLQiM6zehqJ0nC7V kVkQIBIIEQCFglulz6E  yUFBdH0tJ9A /1b8vdIIAACIAACmhNYmpC wQe h6ywwn  yvNzexdwTEhPbKjl0IGEDtAAIGICAh/8AHnQJE tpQ5cg8zSEoAHVbAx4UCAo6xFudjYLVQ5bfN9VIIDwUhAAAQCCFgkumz6E  1kUkANCYU4QBaQbQICFglun9 UJREPEgCAA0IBAICAuIIdCAnoJtEKACo0i3qgqfjB9 DP/4KCFB nwPBAgghIMOhqE14 JeE W7hYWFJ5Mf2CjSLy4IAAQAITMBtAaD/ qQkBU6 1kU kECACWQP4zGt  2rY63wM0AAElCAi/C7 I8RBwC5XY dF6KSsRYaW4 U3VQ /UKAgFE1EogB4EICYg7p3hZKPGsaAB0S4AigAujI4R4IgERJAALSsANAaQID /CQQOIG6ud wsgAAgAJhBAARCA07/t1BWAPBKqwBI0A0A18AIBqA0iAhXYCnCZfU BPIGAiAgC4ICAgL6y4RKiAqN4t64KH4Qv fCOGiCgBPALUDoPIPCYQlEAnuny8U JRbPAB5BAERCIMCb/d v6p20NASC0gDo0AVIAFAWDcQq sEZKAwCl4lZ2MFhI uMGNACgAFgJUZ JXBCAqkMCACAB0ACUB4ElACQEoACAAPgToBs2D6VlwPeouMFAQAAEREwgJKYEJACAACgC4FH 6U1R bHbACAgCICAIgT /bICgAIgCACSi0xIDE3ASgAbgJWYmk6d2iKwAwABsAAAIIJi04YPE/ASgA/gHEkj4SICa UJbCF cJTE0ge I8RCA0AiAAFwDU/dO2D4AQLSAB Bk4IlB xM1BSAAIiED oJEQlgI0ASAAIgCEAgQDpAAQ B/AgxiNAAK UAAjAgYBIgOQA4gHSAvAR8CPECAIACICAAAAgISuCeBCQAqAIgAgARIF3AE3ANACOg AAEACRCgAICAQADWADYBB8ACgAgANgJUCUQA gJQA6QDuAJYCWASABIgJUCRAgkASAA6AGwAwASBCgADAICIRAIiAhAIcAbACDABICXASgAGAACASIHEAFABwCAAJAACQDYARAIAFQAAAj UAg AAIwCIAFQBJAPIIkAGYCdAnACmAbgJEAKQDWAHEAJAFAAZAKCACAB gJECUABAAYANgHHAmQAuAI4ADACeAnAAAhKQQAIAEDAC AxABgBOgF8BP2lAARAI4AagDwAWAwAByANgIEA7gC4ARgAIAH4AwAHAALAC4CAAFAABALUCdgCAMxAnAIgESAQAASA6ASoBA4EnAIAAVACuAFIAnAH ACdgC4C8gA4ApgEcAbACiAJAAgABCC4DEwB8AJwC7AH QDUAnYCQAGgBCAJ0CgAA9gBCA6AGAAqAUEAgAEIBJAagAGgDTAPYCvATAAjACgAhAKIAAAFwCgAFABAABCBOoJSAHCARAAEIDoAZgBGAYgHgADgC7AI4CUAAkAPIC gHwAQgDYCFAaAAyAWAPgD gBUAbgHCAJABMAt/8JJAgADgAFAIJAHIC gDwAMgCAA9ATuBAABCAJgDSAB gLUAbQFsAHQDOAE ABfgQQCVAE4C dALYCXAUuAqQARAGgASAJ0BAADSADAAgAJQAKQBwAFQD6Am8C gCYAnYAcAJcAmACNAgAAgAZAE4CfAL QEAA4gHcCfAPYCdALQCZAM wD4AYADuAQgFYAKAEIBaAB gJEAagFOA6ABoAHQCRAFYCAABAB ACWAt AIcBhgBu/4 wDLAPCAQADqAFgCWAp8BaADAAmACQABwBvAMAAvAMwAvAKgARgCFARABCA7AIkC1gKdAlgB QC4AGABGAHcBKAE0AqADGApgBcA5gBQAJwB7AP4AZgLACZAL4DagKoA4QDIAJ YCsAqQDOAmAC Ag gHSAbADQA6ABcAZgAEATgB3A5QBNgqAAFA8AWAagAJQF4CvgJIAKAAnABwALQCyAPgCVAlQB4AMgCYB TAM YBvgPkAzgLEAUgCkAqQCoAEgCdAlEAWAAgAb8AoADYBBAK4CDAC8AUgC3AEgA6gHoAUQBcAQgBJAgYCBgIk//7/QEIAtwBAASgAUgJIAPQC0ALgCAALgDJAlAAtAFAAL gHQD9ALgCZAM6wCkAkQBpAE4ClAFAANQCCAGIBnAI4CBAKACBAOQAbgMsBXABeBAABOAAABgANgJcCCgCAA3APQAUgD/ArgJkCjgAYBaQIWAs gDgABgB4AMwCNgEgAgQC/Ao8APAC8AnQCjgBMAhgAOA0gBXAKgAmALgCWAMQAnAJoAyAJwAJAFYC gJMAbgDgALgFEAAgAUgLAABcBvAOIAUgCeAWACSAHwB4AKoAAQBNAJECkQBaA1AC9AHQA gAQgCEAJQCfAnYDCAIgCUAtgBDAhYCqQJQCGwEoApADoAJgFIAHQCBAGgAUgC4AtAFcA4wDXAJIAJAKkAmAAA4CEAAIBvAIIC gBgAgYDEgOAAFAJJANIC WADOAMwDBAqwBNAAwB4gC  gFEANABMAKoAuQCdA3QCLAFoAugJECSgAkAu /IIAA YSAB8A7AGAC gBeAtIC1AE4A8AD4AhgCdAoIATwBSAQYBTgJ A0gCRAFQDnASgBtgAoAnAEKAowA8ASgBYAS4AugJIC UgDwA7gJeAuQC+Am4A9gBUAlgAnAGIBpAHwB4wD1ANwCeAE0A4QCNAJACLwDUAWgABAFAAngD3ANIBRgFcA7QBdA8QC4BKAI AJgBTAF AYgDuApgCZACwBcQFZAF4AYwBSAJgBSAG4B4QK7AXACkQBdAB4COAHUCJgFkASwCB gKAAHQBAAIkCKgBMArwBfAQsBTwBTgCBgJuAnwCuQJCAWIBnAOcAagAJgLiADABNAIwAFgIgAhQB/AiQBRAJUAcAD6AKQBGgFYCSQA4AIYE4AdAI2AeACUgC YA AgK/AVQBkAQwCMAA4ADAK wBSAWQCyAJQCHAF ABrALoAgAAsAswFDAS4BuAN4CDAI gBCAIkAtgAFgLcAvgBvAIYCoADWAHEAl QDBAbAEhALQBugMoCrgJvAS4C YC7gH/ADYATAF4AaAH2AXwCvAKIAvg H0AugCuAJQBSAJQD YDfAFYBRgJ3ARQBKAMgCpAEkAkQCFAWgBNAJ AZQCTAQkASgBYAMqC8AT4BC wF3ALUAeQDJAGYBnAKgCeAPYDqAAQBbgLwATAB7AUQBCAWoBRAIkCqADwAc4D QCRAKyAtAC gFoAuQBTALkAlgDUA7gJXARwDJALIBLgMMAzABSAFIBggFQA7gLgAeIC1gF  SALgC gJIAJoAYQBmAKYBvAIEAWgCRACoByAJkAl4CLgJkAJIBOAFiBNgDaAsYCEAL YChABEApQBWAbYDWAI4CigAAA6gFoB3ACpAIIAbALEAcAAJgHMBUgBf AlwCwAOoBMAJoACAC/AEkCigKCAggB2A7AD AoYAVgJMAoABDAGsA hAOQBpAFYBJALgAbwFoAd IBLAKcBxQFcA8wCKAKgByAAkAZoGsAv4BPAPk AX4CvgL0AXQD/AJoAXgGHAi IBPgG4A7QCFgL8Au wDZAJAAXQF6AMYBLgK QBggJIAjACaA XAHuAo4A0wCvALQBJgMUBbgNYB IB wCpAJEAjQC gFkAXwD4AIcBiwD IArAL4ATwCPASsBOwExAVIB IAkwCLgNEAsQF3AIwAswBkAagBJgMMAAEBCAJoAbgDkAqABwATgBH Al4BxAIABAYBIgDsAQgCrAF4A0QDJAJwA8gDVAF4CQwFSAO4CpwC  /oAqQCvADYBYgIAA5AJIBTQB4AIQADABoARgA9gJ AIYAVgJMATYDqAJkAswFoAI gCgABMArgDEAagBkATwDHASwBLACsAgwDNAJoAswF AwYCqAL ABTgJIA8QD8AdgChgJO AkwCqAKAAugC4AGAB1AL4A/gDRAJMAcwCmAJYBoQCoATgBjAJgASABKAFCBIwFOAggBwAKgEoAcYDtAKUBVgJ4CAAh4CuAKMACQBjAKsAoQCKAJ4AgQBSAYQCmgGeBKoAdQE4AjIC3AM 4BJAD4BAQCpAMEByAAOAbgDlAPoBvgHuAhwD7ANIAlQByAiMBVAH/AogBgAGYBPQC4AAUBT gCgA3AB8ARwDSALIAuABFAbkCbwCOASwCMgJuAcYByAFEAJQBGAN4AEIKAB9AJQBbAFIANQBLgLYAUgACAB5AC IByA4ABFAE4AoQABAMIBvAOQ AcwFRASYBcAIWAQgAwAKgBQAWwBJgIMAQQBYAEEA3wAoAJQAwgBIAPQBwAOgC gJ8AzAGUBHAC4BZQFUAGIABgFHAa4BYgFYBVAL6AcYAGgKHAY4AoAH4AiwBZ gGSAKoCnwFCAp8AFQB Ag0AWgD2AkIAjwFXAIIBJgJVAdQBkgBKAwYC6AL4BKwKsAOoASgGOARgD8AJYC0AHgAZwD2AF4BhgFJAbwDqAKoA9gKhAKwAoQD3AHYAqYBJQHsAJEC  AJcBpAFoAWECSgFJAKQCmgAgBSAV4B/AR YAXgGIBNgM YA5AELAGoBNQK1AVwCeAAUA6AF6AUgAsQCMAPYCiQBQARQBYwFoAP4CAAF4AWgFBAsYCrQCMAJEAHgFqAcwBaAJQCWgBIBKQA8AqgBkQC/Al gDXAPsBE/9//ew4BAQEBAf/+A7B6RDPEDgRAoEgCEA9wERAbkBEQEPATAA1AEEAE4AaIBgwCIAZgBbgBEAIQAVQBKAMgAnABkABwBBAGcBPAEWApIA3AM4AXgJJALwAawGsAH4CrAAcAkwCggD cAgwB7AFoBYABDAGAB2AM4B/ANQF8B7wBVAdwDOAZMBbgC YAYgH4AV wCwAOgA/AKEAwQBsARgBLgESAMoAqACKAOg Ag7gFkAfoCLwJ5AfgChgL8AdYBRALSA/ABfAQQAvgEQAXgBkAFIBAAKAABgDhAW8BsIBNAPuA1gCIAVAASAAIADAALwCkAPAB5gGg/x8ABrADyBBYBABAqAAQA7gIIAJACqAHkBUgCdAJgATABNgH Asw/f/U IBAwAQAEQ//8C7gIyAjgCzAIMA+4CWgJEANICNgFQAXcA0gB9AJwAXACRAFmAdoBNwC4AHcBOIB6gDUAlwBAAN4CTAJ6AkECXgBfANcBYgEQAZgCMAJwAoABDAOIAhABQAJAAvAE8AWgDgA0f//AICAiIBJgEwAyQCCADsAiwD5AEIA1ADsAjwDCAMIA4gC7AH0Ad4C8AHQArQCtgHQAXAB0/8P//EBAQE/AQcBuwBJAEwAnIDkAGoAEQBkAFQAIgAUAB1AT//8ABRAA4AKoDJAHkAlgBYAE YBvgHyAWgCGALAA2gCkAIgA5gE4AZoCGAJIAXQBOAJ0AdQC6AIoAuQBOAPQAwQDkAGQAXgCAASgDaAJYBAADJAHQAnQBzAJoA1gCkAKcAnQCYAJ kB5gHkAPwBjAF7AU4BCwFsAKMBYgFKAUoCvgI4ArgCSAMYB2gKYAzgC2AIsBLgJMArgChAEQAqQDTAK2AUkBhgFHAaEBrAHOAgQCYgJvAooCfgLGAvQCIwMUA2UDlwPAAuED/AMTBFkEZQSDBLkE9gUTBTQFXwWEBaMF vgX2BhAGKoZXhniGcYaIho+GlUabBqKGrEa4hs8G08bgxvNG/sb7RwGHBEcLhxJHF0clxy/HPcc8R0aHS0dah2QHa0d0B33HiQeOh55HpMeux7cHwEfKR9IH4Mfrx/UH/kgFSAwIEwgaSCNILkg8SEQITUhUiFxIZAhsyHIIeIiACIbIjkiWCJ5Ipkilyy/LIIspy8vLysvPC9HL1EvXS9pL3IvgC+LL5gvpC+xL78vzS/bL+sv+TAGMBUwJTAzMEMwUTBhMHAwhDCSMKEwsDDBMNMw4jD1MAUxFDEnMTUxSzFcMWkxfjGLMZwxqzG6Mckx2DHoMfkyCDIXMigxNzFHMVkxazF7MYcxlDGiMbIxwDHNMdsx6TH5MgkyGDInMjkyRzJVMmcydzKJMpoyqzK7MsgxFzEm MUcxZjFqMW0xcDF0MXYxeDGBMYsxljGgMakxsjG8McQxzDHWMeAx6THxMfsx/jICMgcyDDIRMhgyHTIkMioyMDI2MjwyQjJKMlAyWDJeMmQyajJyMngyfTKDMokyiTKQMpcynTKjMqsysTC7ML8wxDDKMNAw1DDZM OEw5jDsMPEw+DD+MQQxCTEPMRUxGjEfMSQxKjEwMTYxPTFEMUsxUjFYMV4xYzFoMW0xcDF3MX4xgzGLMZAx lDGYMZ4xojGnMa0xszG4Mb4xxDHKMdAx1DHZMd4x4jHnMewx8TH3Mf0yBDIKMhAyFzIeMiUyLDIzMjoyQTJHMk8yVjJeMmQybDJyMnkygjKJMpEymDKgMqkysDK3Mr4yxTLLMtEy2TLgMucy8TL5MwEzBzMOMxYzHDMk MywzOjM8Mz8zQjNDM0YzSzNQM1UzWTNhM2UzaTNsM2+zc7N5s3qzfTN/M4AzhDOG M4gziTOKM4wzjTOOM48zkDORo5Kjk+OUI5VjlqOX45ijmaOa45vjnCOdY53jnyOfw6BDoYOiw6NjpCOko6UjpaOmI6ajpyOno6gDqGOoI6ljqaOp46ojqmOqo6rjqyOrY6ujq+OsI6xjrKOs462jreOuI65jrqOu467jr2Ovo6/jsCOwo7Dj sWOxo7HjsiOyY7KjsuOzI7NjtCO0Y7UjtWO2o7bjtxO3k7gTuFO4k7jTuRO5U7mTudO6E7pTupO607sTu1O7k7vTvBO8U7yTvNO9E71TvZO9074TvlO+k77Tv1O/k7/TwBPAU8ETwVPCE8JTwxPDU8QTxFPFE8VTxhPGU8cTx1PIE8hTyRPJU8oTylPLE8tTzBPMU80TzVPOE85TzxPPU9AT0FPRE9FT0hPSU9MT01PUE9RT1RPVU9YT1lPXE9dT2BPYU9kT2VPAE9pT2xPbU9wT3FPdE91T3hPeU98T31PgE+BT4RPPk+GT4hPik+MT45PkE+ST5RPek+bT5xPnU+eT59PoE+hT6JPo0+kT6VPpk+nT6hPqU+qT6tPrE+tT65Pr0+wT7FPsk+zT7RPtU+2T7dPuE+5T7pPu0+8T71Pvk+/T8BPwU/CT8NPxE/FT8ZPx0/IT8lPyk/LT8xPzU/OT89P0E/RT9JP00/UT9VP1k/XT9hP2U/aT9tP3E/dT95P30/gT+FP4k/jT+RP5U/mT+dP6E/pT+pP60/sT+1P7k/vT/BP8U/yT/NP9E/1T/ZP90/4T/lP+k/7T/xP/U/+T/9QAFABUAJQBFAFUAZQB1AIUA lQClALUAxQDVAOUA9QEFARUBJQFFAUUBVQFlAXUBhQGVAaUBtQHFAdUB5QH1AgUCFQIlAjUCRQJVAmUCdQKFApUCpQK1AsUC1QLlAvUDBQMVAyUDNQNFA1UDZQN1A4UDlQOlA7UDxQPVA+UD9QQFBBUEJQRFBEUEVQRlBHUEhQSVBKUEtQTFBNUE5QT1BQUFFQUlBTUFRQVVBWUFdQWFBZUFpQW1BcUF1QXlBfUGBQYVBiUGNQZFBlUGZQZ1BoUGlQalBrUGxQbVBuUG9QcFBxUHJQc1B0UHVQdlB3UHhQeVB6UHtQfFB9UH5Qf1CAUIFQglCDUIRQhVCGUIdQiFCJUIpQi1CMUIIIQilCLUItQi1CLUIvQjFCMUI1QjVCNUI3QjdCN0I5QjlCOUI7QjtCO0I9Qj1CPUI/Qj9CP0JJQR0lBHSUEfJQRclBFyUEZJQRklBGyUEbJQRslBISUEhJQSElBIyUEj JQSMlBI1UEjVQSNVBI1UEjVQSNVBI1UEjVQSNVBI1UEjVQSNVBI1UEjVQSNVBI1UEjVQSNVBI1UEjVQSNVBI1UEjVQSNVBI1UEjVQSNVBI1UEjVQSNVBI1UEj"
      />
    </defs>
  </svg>
);

const CountriesPinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7.62245 13.5468C8.01358 13.1432 8.27945 12.6287 8.38774 12.0693C8.49522 11.5098 8.44027 10.9294 8.22854 10.4025C8.01681 9.87552 7.65881 9.42443 7.19818 9.10759C6.73836 8.79074 6.19773 8.62148 5.64417 8.62148C5.09061 8.62148 4.54997 8.79074 4.09015 9.10759C3.63033 9.42443 3.27153 9.87552 3.0598 10.4025C2.84807 10.9294 2.79312 11.5098 2.9006 12.0693C3.00889 12.6287 3.27476 13.1432 3.66589 13.5468L5.64336 15.5871L7.62083 13.5468H7.62245ZM5.64498 17.9184L2.53695 14.7132C1.92278 14.0787 1.50417 13.2708 1.33446 12.3919C1.16476 11.5123 1.25204 10.6009 1.58498 9.77213C1.91793 8.94333 2.48119 8.23543 3.20365 7.73765C3.92611 7.23987 4.77625 6.97389 5.64498 6.97389C6.51371 6.97389 7.36385 7.23987 8.08631 7.73765C8.80877 8.23543 9.37203 8.94416 9.70498 9.77213C10.0379 10.6009 10.1252 11.5123 9.95549 12.3919C9.78579 13.2716 9.36799 14.0796 8.75301 14.7132L5.64498 17.92V17.9184ZM5.64498 12.743C5.32739 12.743 5.02192 12.6129 4.79726 12.3811C4.5726 12.1493 4.44654 11.835 4.44654 11.5064C4.44654 11.1779 4.5726 10.8644 4.79726 10.6318C5.02192 10.4 5.32658 10.2699 5.64498 10.2699C5.96338 10.2699 6.26804 10.4 6.4927 10.6318C6.71735 10.8636 6.84342 11.1779 6.84342 11.5064C6.84342 11.835 6.71735 12.1493 6.4927 12.3811C6.26804 12.6129 5.96338 12.743 5.64498 12.743Z"
      fill="#18181B"
    />
    <path
      d="M16.3329 7.82301C16.724 7.41945 16.9899 6.90499 17.0981 6.34551C17.2056 5.78603 17.1507 5.2057 16.9389 4.67874C16.7272 4.15178 16.3684 3.70069 15.9086 3.38384C15.4488 3.067 14.9081 2.89774 14.3546 2.89774C13.801 2.89774 13.2604 3.067 12.8006 3.38384C12.3407 3.70069 11.9819 4.15178 11.7702 4.67874C11.5585 5.2057 11.5027 5.78603 11.611 6.34551C11.7185 6.90499 11.9852 7.41945 12.3763 7.82301L14.3538 9.86332L16.3312 7.82301H16.3329ZM14.3554 12.1955L11.2474 8.99033C10.6332 8.35581 10.2146 7.54785 10.0449 6.66902C9.87516 5.78936 9.96244 4.87802 10.2954 4.04922C10.6283 3.22042 11.1916 2.51252 11.9141 2.01474C12.6365 1.51696 13.4858 1.25098 14.3554 1.25098C15.2249 1.25098 16.0743 1.51696 16.7967 2.01474C17.5192 2.51252 18.0824 3.22125 18.4154 4.04922C18.7483 4.87802 18.8348 5.78936 18.6659 6.66902C18.4962 7.54869 18.0784 8.35664 17.4634 8.99033L14.3554 12.1971V12.1955ZM14.3554 7.01922C14.0378 7.01922 13.7323 6.88915 13.5077 6.65735C13.283 6.42555 13.1569 6.11121 13.1569 5.78269C13.1569 5.45417 13.283 5.13983 13.5077 4.90803C13.7323 4.67624 14.037 4.54616 14.3554 4.54616C14.6738 4.54616 14.9776 4.67624 15.2031 4.90803C15.4278 5.13983 15.5538 5.45417 15.5538 5.78269C15.5538 6.11121 15.4278 6.42555 15.2031 6.65735C14.9784 6.88915 14.6738 7.01922 14.3554 7.01922Z"
      fill="#18181B"
    />
    <path
      d="M9.47262 3.93116C9.49686 3.86363 9.52191 3.79609 9.54858 3.72938C9.76596 3.18825 10.0642 2.6938 10.431 2.25856C10.2743 2.24938 10.1167 2.24271 9.95749 2.24271C9.67949 2.24271 9.39908 2.25772 9.12432 2.2869C6.76945 2.53871 4.65541 3.84862 3.32443 5.88059C3.06745 6.27248 2.84684 6.68438 2.66097 7.11045C2.69168 7.08794 2.72239 7.06543 2.7539 7.04375C3.47394 6.54764 4.29337 6.2483 5.14836 6.16409C6.20458 4.91422 7.67616 4.11793 9.28998 3.94534C9.34978 3.93867 9.41201 3.93533 9.47262 3.93116Z"
      fill="#18181B"
    />
    <path
      d="M16.3071 11.1804C15.9741 14.4914 13.254 17.0821 9.95848 17.0821C9.34592 17.0821 8.73983 16.9928 8.15879 16.8169C8.08202 16.7936 8.00606 16.7685 7.9301 16.7427L6.68559 18.0268C7.01611 18.1802 7.35552 18.3127 7.70382 18.4178C8.43356 18.6388 9.19157 18.7505 9.95848 18.7505C14.3692 18.7505 17.9581 15.0476 17.9581 10.4967C17.9581 10.2449 17.9257 9.75043 17.9257 9.75043C17.9257 9.75043 16.3087 11.1604 16.3071 11.1804Z"
      fill="#18181B"
    />
  </svg>
);

export interface ImageTileProps {
  /** Image source URL */
  src?: string;
  /** Alt text for the image */
  alt?: string;
  /** Show loading skeleton */
  isLoading?: boolean;
  /** Show error state */
  hasError?: boolean;
  /** Callback when download button is clicked */
  onDownload?: () => void;
  /** Callback when tile is clicked */
  onClick?: () => void;
  /** Additional class name */
  className?: string;
  /** Country label to show in corner */
  countryLabel?: string;
  /** Marks the asset as sourced from the extended-knowledge library; renders a book icon badge. */
  isExtendedKnowledge?: boolean;
  /** Shows a "Beta" tag overlay; typically paired with extended-knowledge assets. */
  showBetaTag?: boolean;
  /** Shows footer section with extended knowledge icon, beta tag, and dimensions */
  showFooter?: boolean;
  /** Image dimensions string to display in footer (e.g. "950 x 650") */
  dimensions?: string;
  /** Category of the asset - determines which icon to show in footer */
  category?: "global" | "us" | "local" | "archetype";
}

/**
 * ImageTile - A tile component for displaying generated images
 *
 * Features:
 * - Default state: Image with border-radius, subtle border
 * - Hover state: Overlay with download button
 * - Loading state: Skeleton with shimmer animation
 * - Error state: Error icon with message
 * - Uses capsule-preset design tokens
 *
 * @example
 * ```tsx
 * <ImageTile
 *   src="https://example.com/image.jpg"
 *   alt="Generated image"
 *   onDownload={() => handleDownload()}
 *   onClick={() => openPreview()}
 * />
 * ```
 */
function ImageTile({
  src,
  alt = "Image",
  isLoading = false,
  hasError = false,
  onDownload,
  onClick,
  className,
  countryLabel,
  isExtendedKnowledge = false,
  showBetaTag = false,
  showFooter = false,
  dimensions,
  category,
}: ImageTileProps) {
  const [imageLoaded, setImageLoaded] = React.useState(false);

  const handleDownloadClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDownload?.();
  };

  // Loading state - skeleton with shimmer animation
  if (isLoading) {
    return (
      <div
        className={cn(
          "relative flex flex-col overflow-hidden rounded-2xl",
          "border border-solid border-stroke-secondary bg-bg-primary",
          className,
        )}
      >
        {/* Skeleton image area */}
        <div className="relative aspect-square w-full overflow-hidden bg-[#e4e4e7]">
          {/* Shimmer animation overlay */}
          <div
            className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite]"
            style={{
              background:
                "linear-gradient(90deg, transparent 0%, rgba(248,252,255,0.6) 50%, transparent 100%)",
            }}
          />
        </div>
        {/* Loading text footer */}
        <div className="flex h-8 items-center px-3">
          <span className="text-xs font-medium leading-[18px] text-text-subtle">
            Image loading . . .
          </span>
        </div>
      </div>
    );
  }

  // Error state
  if (hasError) {
    return (
      <div
        className={cn(
          "relative flex aspect-square flex-col items-center justify-center gap-2 overflow-hidden rounded-2xl",
          "border border-solid border-stroke-critical bg-bg-secondary",
          className,
        )}
      >
        <RiErrorWarningLine className="size-8 text-icon-critical" />
        <span className="text-xs text-text-critical">Failed to load</span>
      </div>
    );
  }

  // Empty state (no image yet) - placeholder with icon
  if (!src) {
    return (
      <div
        className={cn(
          "relative flex flex-col overflow-hidden rounded-2xl",
          "border border-solid border-stroke-secondary bg-bg-primary",
          className,
        )}
      >
        {/* Placeholder image area */}
        <div className="flex aspect-square w-full items-center justify-center bg-[#e6f4ff]">
          <RiImageLine className="size-6 text-icon-disabled" />
        </div>
      </div>
    );
  }

  // Image loaded state
  return (
    <div
      className={cn(
        "group relative flex flex-col cursor-pointer overflow-hidden rounded-2xl",
        "border border-solid border-stroke-secondary bg-bg-primary",
        "transition-all duration-200 hover:border-stroke-primary hover:shadow-md",
        className,
      )}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      aria-label={`View ${alt}`}
    >
      {/* Image */}
      <div className="relative aspect-square w-full overflow-hidden">
        {/* Extended-knowledge badge - top-left (hidden when footer is shown) */}
        {isExtendedKnowledge && !showFooter && (
          <div className="absolute top-2 left-2 z-10">
            <SystemTooltip
              content="Extended Knowledge"
              side="top"
              sideOffset={6}
            >
              <span
                className={cn(
                  "flex size-7 items-center justify-center rounded-full",
                  "bg-bg-primary/95 text-icon-primary shadow-sm",
                )}
                aria-label="Extended knowledge asset"
              >
                <RiBook2Line className="size-4" />
              </span>
            </SystemTooltip>
          </div>
        )}
        {/* Beta tag - top-right (hidden when footer is shown) */}
        {showBetaTag && !showFooter && (
          <div className="absolute top-2 right-2 z-10">
            <span
              className={cn(
                "rounded bg-bg-primary/95 px-2 py-[2px]",
                "text-[10px] font-semibold uppercase tracking-wide text-text-primary",
                "shadow-sm",
              )}
            >
              Beta
            </span>
          </div>
        )}
        <img
          src={src}
          alt={alt}
          className={cn(
            "size-full object-cover transition-transform duration-200",
            !imageLoaded && "opacity-0",
            "group-hover:scale-105",
          )}
          onLoad={() => setImageLoaded(true)}
        />

        {/* Loading placeholder while image loads */}
        {!imageLoaded && (
          <div className="absolute inset-0 bg-[#e4e4e7]">
            <div
              className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite]"
              style={{
                background:
                  "linear-gradient(90deg, transparent 0%, rgba(248,252,255,0.6) 50%, transparent 100%)",
              }}
            />
          </div>
        )}

        {/* Hover overlay - semi-transparent dark background */}
        <div
          className={cn(
            "absolute inset-0 rounded-t-2xl",
            "bg-[rgba(15,23,42,0.4)]",
            "opacity-0 transition-opacity duration-200 group-hover:opacity-100",
          )}
        >
          {/* Expand Image label - top center */}
          <div className="absolute top-4 left-1/2 -translate-x-1/2">
            <span className="rounded bg-black px-2 py-[1px] text-xs leading-4 text-white whitespace-nowrap shadow-[0px_4px_8px_rgba(2,0,94,0.1),0px_2px_4px_rgba(2,0,94,0.06)]">
              Expand Image
            </span>
          </div>

          {/* Download button - bottom center */}
          {onDownload && (
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2">
              <SystemTooltip content="Download" side="top" sideOffset={8}>
                <button
                  type="button"
                  onClick={handleDownloadClick}
                  className={cn(
                    "flex items-center justify-center rounded-full p-2",
                    "bg-white text-icon-primary",
                    "transition-colors hover:bg-bg-hover",
                    "focus:outline-none focus-visible:ring-2 focus-visible:ring-stroke-blue",
                  )}
                  aria-label={`Download ${alt}`}
                >
                  <RiDownloadLine className="size-5" />
                </button>
              </SystemTooltip>
            </div>
          )}

          {/* Country label - bottom left (hidden when footer is shown) */}
          {countryLabel && !showFooter && (
            <div className="absolute bottom-4 left-4 flex items-center gap-2">
              <span className="rounded bg-bg-primary/90 px-2 py-1 text-xs font-medium text-text-primary">
                {countryLabel}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* Footer section with category icon, extended knowledge icon, beta tag, and dimensions */}
      {showFooter && (
        <div className="flex h-8 items-center gap-1 bg-bg-secondary px-2">
          <div className="flex flex-1 items-center gap-1">
            {/* Category icon - shown first */}
            {!isExtendedKnowledge && category === "global" && (
              <SystemTooltip content="Global" side="top" sideOffset={6}>
                <span className="flex items-center justify-center rounded-lg p-1">
                  <RiGlobalLine className="size-4 text-icon-primary" />
                </span>
              </SystemTooltip>
            )}
            {!isExtendedKnowledge && category === "us" && (
              <SystemTooltip content="US" side="top" sideOffset={6}>
                <span className="flex items-center justify-center rounded-lg p-1">
                  <USFlagIcon />
                </span>
              </SystemTooltip>
            )}
            {!isExtendedKnowledge && category === "local" && (
              <SystemTooltip content="Local" side="top" sideOffset={6}>
                <span className="flex items-center justify-center rounded-lg p-1">
                  <RiMapPinLine className="size-4 text-icon-primary" />
                </span>
              </SystemTooltip>
            )}
            {!isExtendedKnowledge && category === "archetype" && (
              <SystemTooltip content="Archetype" side="top" sideOffset={6}>
                <span className="flex items-center justify-center rounded-lg p-1">
                  <CountriesPinIcon />
                </span>
              </SystemTooltip>
            )}
            {isExtendedKnowledge && (
              <SystemTooltip
                content="Extended Knowledge"
                side="top"
                sideOffset={6}
              >
                <span className="flex items-center justify-center rounded-lg p-1">
                  <RiBook2Line className="size-4 text-icon-primary" />
                </span>
              </SystemTooltip>
            )}
            {showBetaTag && (
              <span className="flex h-[18px] items-center rounded-md border border-stroke-secondary bg-bg-hover px-1 text-[10px] font-bold text-text-secondary">
                BETA
              </span>
            )}
          </div>
          {dimensions && (
            <span className="text-xs font-medium text-text-primary">
              {dimensions}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

ImageTile.displayName = "ImageTile";

export { ImageTile };
